import { AsyncState } from '@c42/constants';
import { StsTenantInfo } from '@c42/jwt/dist/constants';
import _debounce from 'lodash/debounce';
import React from 'react';
import { useHistory } from 'react-router';
import c42Jwt from '../../constants/c42Jwt';
import { LOGIN_INDEX } from '../../constants/routes';

type Response = {
  loadingState: AsyncState;
  tenantInfo: StsTenantInfo;
};

export const useTenantInfo = (tenantIdOrX1AccountCode: string): Response => {
  const [loadingState, setLoadingState] = React.useState(AsyncState.NOT_STARTED);
  const [tenantInfo, setTenantInfo] = React.useState<StsTenantInfo>(null);
  const history = useHistory();

  React.useEffect(() => {
    if (!tenantIdOrX1AccountCode) {
      setLoadingState(AsyncState.NOT_STARTED);
      setTenantInfo(null);
      return;
    }

    const loadTenantInfo = _debounce(async () => {
      try {
        setLoadingState(AsyncState.LOADING);
        const tenantInfo = await c42Jwt.getTenantInfo({ tenantIdOrX1AccountCode });
        setTenantInfo(tenantInfo);
        setLoadingState(AsyncState.DONE);
      } catch (e) {
        if (e?.status === 401 || e?.status === 403) {
          history.push(LOGIN_INDEX);
        } else {
          setTenantInfo(null);
          setLoadingState(AsyncState.ERROR);
        }
      }
    }, 200);

    loadTenantInfo();
    return () => loadTenantInfo.cancel();
  }, [tenantIdOrX1AccountCode]);

  return {
    loadingState,
    tenantInfo,
  };
};
